import React, { useState } from "react";
import DragItemWrap from "components/atoms/DragItemWrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Pane } from "evergreen-ui";

const FieldsOrder = ({ data, setOrder }: any) => {
  const [dataList, setList] = useState([...data]);
  const reorder = (list: any, startIndex: any, endIndex: any) => {
    const result: any[] = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const getListStyle = (isDraggingOver: any) => ({
    width: "100%",
  });

  const getItemStyle = (isDragging: any, draggableStyle: any) => {
    let styles = {
      ...draggableStyle,
    };
    if (isDragging) {
      styles.background = "lightgrey";
      styles.left = 24;
    }
    return styles;
  };

  const onDragEndHandler = (result: any) => {
    const newList = reorder(
      dataList,
      result.source.index,
      result.destination.index
    );
    try {
      const listId = newList.map((item: any) => item.id);
      setList(newList);
      setTimeout(() => {
        setOrder(newList);
      }, 400);
    } catch (e) {}
  };
  const columnHiderHandler = (id: any, e: any) => {
    const list = dataList.map((item) => {
      if (item.id === id) {
        return { ...item, isVisible: e };
      }
      return item;
    });
    setList(list);
    setTimeout(() => {}, 300);
  };

  if (!data.length) {
    return "Please add fields";
  }

  return (
    <div>
      <DragDropContext onDragEnd={onDragEndHandler}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {dataList?.map((item: any, idx: any) => {
                return (
                  <Draggable
                    draggableId={item.name}
                    key={item.name + idx}
                    index={idx}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <DragItemWrap>
                          <Pane
                            height={"36px"}
                            display={"flex"}
                            alignItems={"center"}
                            gap={"10px"}
                          >
                            {item.name}
                          </Pane>
                        </DragItemWrap>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default FieldsOrder;
